import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_btn_dropdown, {
    icon: "fa fa-info-circle",
    label: _ctx.label,
    rounded: "",
    flat: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_list, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resourceGroups, (resourceGroup) => {
            return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
              key: resourceGroup.label,
              clickable: "",
              onClick: ($event: any) => (_ctx.openModal(resourceGroup))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: resourceGroup.icon
                    }, null, 8, ["name"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(resourceGroup.label), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_close_popup]
            ])
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["label"]))
}